<div fxLayout="column">


    <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center" style="height: 50px; margin-bottom: 20px;">
        <span class="pageTitle" fxFlex="95">Αποστολή SMS μηνύματος</span>
        <span><mat-icon (click)="close()">close</mat-icon></span>
    </div>

    <div fxLayout="row" style="height: 450px; border: 1px solid lightgray;">
        <app-text-editor (editorOutputContent)="updateMessage($event)" [plainText]="true"></app-text-editor>
    </div>

    <div *ngIf="mode ==='default'" fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" style="margin-bottom: 10px; margin-top: 20px;">
        <label style='font-family: "Century Gothic", "Helvetica Neue", sans-serif'>  Αποστολή σε όλους όσοι έχουν επιμέλεια (Προεπιλογή)</label>
    </div>

    <div *ngIf="mode ==='default'" fxFlex="grow" fxLayout="row" fxLayoutAlign="center center" style="height: 50px; margin-bottom: 20px;">
        <label style='font-family: "Century Gothic", "Helvetica Neue", sans-serif'>Αποστολή σε όλους όσοι έχουν επιμέλεια ΚΑΙ σε αυτούς που δεν έχουν επιμέλεια</label>&nbsp;&nbsp;<mat-slide-toggle [(ngModel)]="sendToAll"></mat-slide-toggle>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="10px">

        <button mat-raised-button [disabled]="isSendingMessage" [class.spinner]="isSendingMessage"
                (click)="promptConfirmation('self')">Δοκιμαστική Αποστολή
        </button>

        <button *ngIf="mode === 'default'" mat-raised-button [disabled]="isSendingMessage" [class.spinner]="isSendingMessage"
                (click)="promptConfirmation('parents')">Αποστολή
        </button>

        <button *ngIf="mode !== 'default'" mat-raised-button [disabled]="isSendingMessage" [class.spinner]="isSendingMessage"
                (click)="promptConfirmation('users')">Αποστολή
        </button>
    </div>


</div>
